import { faStar, faTag, faTags } from '@fortawesome/free-solid-svg-icons';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import serverStorage from './serverStorage';

const DEFAULT_TAGS = [ 'Favorite', 'Hidden' ];
const MAX_TAGS = 10;
const MAX_TAGGED_ITEMS = 1000;

function merge(ids1, ids2) {
    return Array.from(new Set([ ...ids1 || [], ...ids2 || [] ]));
}

async function set(type, ids, tags, retry) {
    tags = new Set(tags);
    if (!retry) retry = 0;

    const json = await serverStorage.getItem('tags') || {};

    // handle adding tags
    for (let tag of tags) {
        // track tags defined
        const newtag = !json[tag];
        json[tag] ??= {};

        // track number of items
        const before = json[tag][type]?.length || 0;
        json[tag][type] = merge(json[tag][type], ids);
        const after = json[tag][type]?.length || 0;

        // limit size of tags
        if (newtag) {
            const num = new Set(Object.keys(json));
            DEFAULT_TAGS.forEach(tag => num.delete(tag));
            if (num.size > MAX_TAGS) throw Error(`You have exceeded the maximum of ${MAX_TAGS} allowed tag names`, { cause: 'tags' });
        }
        if (after > before && after > MAX_TAGGED_ITEMS) throw Error(`You have exceeded the maxium of ${MAX_TAGGED_ITEMS} allowed tags assigned`, { cause: 'tags' });
    }

    // handle removing tags
    for (let tag of Object.keys(json)) {
        if (tags.has(tag)) continue;

        const prev = new Set(json[tag][type]);
        ids.forEach(id => prev.delete(id));

        if (prev.size) {
            json[tag][type] = Array.from(prev);
        } else {
            // remove empty
            delete json[tag][type];
            if (!Object.keys(json[tag]).length) delete json[tag];
        }
    }

    // attempt one retry if any server sync problems
    const success = await serverStorage.setItem('tags', json);
    if (!success && retry < 1) return set(type, ids, tags, retry + 1);
    return success;
}

async function get(type, id) {
    const json = await serverStorage.getItem('tags') || {};

    const tags = [];
    for (let tag of Object.keys(json)) {
        if (new Set(json[tag][type]).has(id)) {
            tags.push(tag);
        }
    }
    return tags;
}

async function existing() {
    const json = await serverStorage.getItem('tags') || {};
    DEFAULT_TAGS.forEach(key => json[key] = true);
    return Object.keys(json);
}

async function assign(type, collection) {
    if (!collection?.length) return; // nothing to assign

    const json = await serverStorage.getItem('tags') || {};

    // first need to setup tag mappings, since JSON is stored to save space
    const idToTags = {};
    Object.keys(json)?.forEach(tag => {
        json[tag][type]?.forEach(id => {
            idToTags[id] ??= [];
            idToTags[id].push(tag);
        });
    });

    // now assign tags to collection items
    collection?.forEach(item => {
        if (idToTags[item.id]) {
            item.tags = idToTags[item.id];
        } else {
            delete item.tags;
        }
    });
}

function icon(tags) {
    if (!tags?.length) return null;

    if (tags?.length > 1) return faTags;
    if (tags?.includes('Favorite')) return faStar;
    if (tags?.includes('Hidden')) return faEyeSlash;
    return faTag;
}

const tags = { set, get, existing, assign, icon, addEventListener: serverStorage.addEventListener, removeEventListener: serverStorage.removeEventListener };
export default tags;